import styled from 'styled-components';

export const Divider = styled.div`
  border-bottom: 1px solid #434343;
  width: 100%;
`;
